import { EvtHeader } from "components/header";
import ClientForm from "@/modules/crm/clients/crud/form";
import React from "react";

const CreateClient = () => {
  return (
    <div className="flex-1 max-w-md">
      <EvtHeader title="Create Client" />
      <div className="p-6 max-w-2xl">
        <ClientForm />
      </div>
    </div>
  );
};

export default CreateClient;
